import type { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag";
import type { WorkDurationType } from "@/pages/human-resources/time-management/business/WorkDurationType";
import type { DisplayOptions } from "@/pages/human-resources/time-management/model/display-options/DisplayOptions";
import type { DurationDisplayUnit } from "@/pages/human-resources/time-management/model/display-options/DurationDisplayUnit";

export type TimeFormatIn = "minutes" | "centiemes";
export type WorkDurationTypeIn = "effectif" | "valorise";
export type ScheduleStateIn = "1" | "2" | "3";

export interface PrintCommonParts {
  etat: ScheduleStateIn;
  idsEmps: number[];
  tags: string[];
  timeFormat: TimeFormatIn;
  withHoraires: boolean;
  withLabels: boolean;
}

export function buildCommonParts(
  employeesIds: string[],
  visibleDailyTags: DailyTag[],
  displayOptions: DisplayOptions,
): PrintCommonParts {
  return {
    etat: "1",
    idsEmps: employeesIds.map((s) => parseInt(s)),
    tags: visibleDailyTags.map((t) => t.id),
    timeFormat: mapToTimeFormat(displayOptions.durationUnit),
    withHoraires: displayOptions.showWorkDuration,
    withLabels: displayOptions.showDayLabel,
  };
}

export function mapToTimeFormat(
  displayUnit: DurationDisplayUnit,
): TimeFormatIn {
  switch (displayUnit) {
    case "HUNDREDTH":
      return "centiemes";
    case "MINUTE":
      return "minutes";
  }
}

export function mapToWorkType(
  workDurationType: WorkDurationType,
): WorkDurationTypeIn {
  switch (workDurationType) {
    case "EFFECTIVE":
      return "effectif";
    case "VALORIZED":
      return "valorise";
  }
}
